var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25h-1.5A2.25 2.25 0 0 0 12 10.5V21M9 13.5h6"
  }))));
};
export default SvgFacebookLogo;